// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1p2EP","boxTitle":"Qualiphy_boxTitle__1LtO3","box":"Qualiphy_box__2zELQ","toggleWrap":"Qualiphy_toggleWrap__1ija5"};